import { EtatWorkflowIncidentEnum } from '@api/enum'

export const isIncidentClosed = (status: EtatWorkflowIncidentEnum) =>
  status === EtatWorkflowIncidentEnum.ABANDONNEE ||
  status === EtatWorkflowIncidentEnum.CLOTUREE_VIPARIS ||
  status === EtatWorkflowIncidentEnum.CLOTUREE_PRESTATAIRE

export const isPrestaIncidentUnaffected = (incident: IncidentResponse) =>
  incident.status === EtatWorkflowIncidentEnum.EN_ATTENTE_DE_PRISE_EN_CHARGE && !incident.technicienAffecteId

export const isIncidentOnStandBy = (status: EtatWorkflowIncidentEnum) =>
  status === EtatWorkflowIncidentEnum.EN_ATTENTE_DE_VALIDATION ||
  status === EtatWorkflowIncidentEnum.EN_ATTENTE_DE_PRISE_EN_CHARGE ||
  status === EtatWorkflowIncidentEnum.EN_ATTENTE_DE_DEVIS

export const isPrestaIncidentInProgress = (status: EtatWorkflowIncidentEnum) =>
  status === EtatWorkflowIncidentEnum.EN_ATTENTE_DE_PRISE_EN_CHARGE ||
  status === EtatWorkflowIncidentEnum.EN_ATTENTE_DE_DEVIS ||
  status === EtatWorkflowIncidentEnum.DEVIS_ENVOYE ||
  status === EtatWorkflowIncidentEnum.EN_COURS_DE_TRAITEMENT

export const isPrestaIncidentPaused = (status: EtatWorkflowIncidentEnum) => status === EtatWorkflowIncidentEnum.EN_PAUSE

export const hasCoordinate = (incident: IncidentResponse) => !!incident.plan?.x && incident.plan?.y
